import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import { useTheme } from '../../../../../ThemeContext';

import styles from './ShowMoreDetails.module.scss';

const ShowMoreDetails = () => {
  const { t } = useTranslation('common');
  const location = useLocation();
  const state = location.state;
  const { universalStyles } = useTheme();

  useEffect(() => {
    if (location.state) {
      sessionStorage.setItem('seeMoreDetails', JSON.stringify(state));
    }
  }, [location.state, state]);

  const ShowMoreData = location.state ?? JSON.parse(sessionStorage.getItem('seeMoreDetails') || 'null');

  const genres: string[] = ShowMoreData?.item?.genre ? ShowMoreData?.item?.genre.split(',') : [];
  const rawTags = ShowMoreData?.item?.tags;
  let tags: string[] = [];
  if (typeof rawTags === 'string') {
    tags = rawTags.split(',');
  } else if (Array.isArray(rawTags)) {
    tags = rawTags;
  }
  const category = ShowMoreData?.item?.category || ShowMoreData?.item?.maCategory;
  const title = ShowMoreData?.item?.title || ShowMoreData?.item?.maTitle;
  const description = ShowMoreData?.item?.description || ShowMoreData?.item?.maDescription;

  return (
    <div>
      <h2 className={styles.heading} style={universalStyles.primaryTextColor}>
        {title}
      </h2>
      <div className={styles.primaryMetaDataContainer} dangerouslySetInnerHTML={{ __html: ShowMoreData?.primaryMetadata }} />
      {genres.length > 0 && (
        <div className={styles.genresContainer}>
          {genres &&
            genres?.length > 0 &&
            genres?.map((item, index) => (
              <div className={styles.genres} key={index} style={{ ...universalStyles?.genre, ...universalStyles.primaryTextColor }}>
                {item}
              </div>
            ))}
        </div>
      )}
      <div className={styles.descriptionContainer}>
        <span className={styles.description} style={universalStyles.primaryTextColor}>
          {description}
        </span>
      </div>
      {ShowMoreData?.item?.audio_language && (
        <div className={styles.detailsContainer}>
          <h3 className={styles.detailsHeader} style={universalStyles.primaryTextColor}>
            {t('show_more.audio_languages')}
          </h3>
          <p className={styles.detailsValue} style={universalStyles.secondaryText}>
            {ShowMoreData.item.audio_language}
          </p>
        </div>
      )}
      {ShowMoreData?.item?.sub_title && (
        <div className={styles.detailsContainer}>
          <h3 className={styles.detailsHeader} style={universalStyles.primaryTextColor}>
            {t('show_more.subtitles')}
          </h3>
          <p className={styles.detailsValue} style={universalStyles.secondaryText}>
            {ShowMoreData.item.sub_title}
          </p>
        </div>
      )}
      {ShowMoreData?.item?.cast && (
        <div className={styles.detailsContainer}>
          <h3 className={styles.detailsHeader} style={universalStyles.primaryTextColor}>
            {t('show_more.cast')}
          </h3>
          <p className={styles.detailsValue} style={universalStyles.secondaryText}>
            {ShowMoreData.item.cast}
          </p>
        </div>
      )}
      {ShowMoreData?.item?.director && (
        <div className={styles.detailsContainer}>
          <h3 className={styles.detailsHeader} style={universalStyles.primaryTextColor}>
            {t('show_more.director')}
          </h3>
          <p className={styles.detailsValue} style={universalStyles.secondaryText}>
            {ShowMoreData.item.director}
          </p>
        </div>
      )}
      {ShowMoreData?.item?.producer && (
        <div className={styles.detailsContainer}>
          <h3 className={styles.detailsHeader} style={universalStyles.primaryTextColor}>
            {t('show_more.producer')}
          </h3>
          <p className={styles.detailsValue} style={universalStyles.secondaryText}>
            {ShowMoreData.item.producer}
          </p>
        </div>
      )}
      {ShowMoreData?.item?.studio && (
        <div className={styles.detailsContainer}>
          <h3 className={styles.detailsHeader} style={universalStyles.primaryTextColor}>
            {t('show_more.studio')}
          </h3>
          <p className={styles.detailsValue} style={universalStyles.secondaryText}>
            {ShowMoreData.item.studio}
          </p>
        </div>
      )}
      {category && (
        <div className={styles.detailsContainer}>
          <h3 className={styles.detailsHeader} style={universalStyles.primaryTextColor}>
            {t('show_more.category', { defaultValue: 'Category' })}
          </h3>
          <div className={styles.categoryBadgeWrapper}>
            <span className={styles.categoryBadge}>{category}</span>
          </div>
        </div>
      )}
      {tags.length > 0 && (
        <div className={styles.detailsContainer}>
          <h3 className={styles.detailsHeader} style={universalStyles.primaryTextColor}>
            {t('show_more.tags', { defaultValue: 'Tags' })}
          </h3>
          <p className={styles.detailsValue} style={universalStyles.secondaryText}>
            {tags.map((tag) => (tag.trim().startsWith('#') ? tag.trim() : `#${tag.trim()}`)).join(', ')}
          </p>
        </div>
      )}
    </div>
  );
};

export default ShowMoreDetails;
